import { useMutation } from '@tanstack/react-query'
import { Input, Space, Typography } from 'antd'
import axiosClient from 'api/axiosClient'
import { setAppSpinning } from 'app/appSlice'
import { useFormik } from 'formik'
import ToastHelper from 'general/helpers/ToastHelper'
import { object, string } from 'yup'
import { forwardRef } from 'react'
import { shallowEqual, useDispatch } from 'react-redux'
import DraggableModal from '../DragableModal/DraggableModal'
import { useAppSelector } from 'hooks/useRedux'

const ModalSendNoticeCancel = forwardRef(
  ({ isOpen, onOpenChange, invoiceId, ticketId, email }, ref) => {
    const systemType = useAppSelector((s) => s.auth.activeInvoice, shallowEqual)
    const appDispatch = useDispatch()
    const initialValues = {
      customerEmail: '',
      customerName: '',
    }
    const validationSchema = object({
      customerName: string().required('Vui lòng nhập tên người nhận!'),
      customerEmail: string()
        .email('Email không đúng định dạng!')
        .required('Vui lòng nhập email!'),
    })
    const sendMailMutation = useMutation({
      mutationKey: ['sendMailNoticeCancel'],
      mutationFn: async (params) => {
        const { formValues, formHelper } = params
        const res = await axiosClient.post(
          email
            ? `/ticket/send-mail-notice-adjust`
            : `/${systemType.ticket ? 'ticket' : 'invoice'}/send-mail-notice-cancel`,
          {
            ...formValues,
            invoiceId,
            ticketId,
          },
        )
        if (res.result !== 'success') {
          ToastHelper.showError('Đã có lỗi trong quá trình gửi mail')
          throw new Error(res.statusText ?? res.result)
        }
        onOpenChange(false)
        ToastHelper.showSuccess('Gửi email thành công')
        formHelper.resetForm({ values: initialValues })
      },
      onSettled: () => appDispatch(setAppSpinning(false)),
      onMutate: () => appDispatch(setAppSpinning(true)),
      // onError: (error) => ToastHelper.showError(error),
    })
    const formik = useFormik({
      initialValues,
      validationSchema,
      onSubmit: (values, formHelper) => {
        sendMailMutation.mutate({
          formValues: values,
          formHelper,
        })
      },
      validateOnChange: false,
      validateOnBlur: true,
    })

    return (
      <DraggableModal
        title={email ? 'Gửi thông báo điều chỉnh' : 'Gửi thông báo huỷ'}
        isOpen={isOpen}
        onOpenChange={(state) => {
          onOpenChange(state)
          formik.resetForm({
            values: initialValues,
          })
        }}
        handleApplyChanges={() => formik.submitForm()}
        ref={ref}
        applyText={email ? 'Gửi thông báo điều chỉnh' : 'Gửi thông báo huỷ'}
        width={'40rem'}
      >
        <form onSubmit={formik.handleSubmit}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <div>
              <Typography.Text style={{ color: '#000' }} strong>
                Tên người nhận
                <span className="ml-1 text-danger">*</span>
              </Typography.Text>
              <Input
                style={{ height: 38 }}
                {...formik.getFieldProps('customerName')}
                placeholder="Nhập tên người nhận"
              />
              <Typography.Text type="danger">
                {formik.getFieldMeta('customerName').error
                  ? formik.getFieldMeta('customerName').error
                  : ''}
              </Typography.Text>
            </div>
            <div>
              <Typography.Text
                style={{ color: '#000' }}
                strong
                type={
                  formik.getFieldMeta('email').error ? 'danger' : 'secondary'
                }
              >
                Email
                <span className="ml-1 text-danger">*</span>
              </Typography.Text>
              <Input
                style={{ height: 38 }}
                {...formik.getFieldProps('customerEmail')}
                placeholder="Nhập email"
                status={formik.getFieldMeta('customerEmail').error && 'error'}
              />
              <Typography.Text type="danger">
                {formik.getFieldMeta('customerEmail').error
                  ? formik.getFieldMeta('customerEmail').error
                  : ''}
              </Typography.Text>
            </div>
            <Typography.Text type="danger">
              {formik.getFieldMeta('type').error
                ? formik.getFieldMeta('type').error
                : ''}
            </Typography.Text>
          </Space>
        </form>
      </DraggableModal>
    )
  },
)

export default ModalSendNoticeCancel
